import { FAQS } from "../../data/landingContent";
import AgentFaq from "./AgentFaq";

export default function FAQ() {
  return (
    <AgentFaq
      sectionId="faq"
      id="home-faq"
      faqs={FAQS}
      kicker="Questions"
    />
  );
}
